module.exports = __webpack_public_path__ + "img/living_1.109ba3d9.jpg";